import React from 'react';
import Button from '@mui/material/Button';

const FormularUnbestimmt = (props) => (
    <p>
        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularMeldung"}}
        >
            01 Meldung
        </Button>

        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularWeitergabe"}}
        >
            02 Weitergabe
        </Button>

        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularHaltungsaenderung"}}
        >
            03 Haltungsänderung
        </Button>

        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularAbmeldung"}}
        >
            04 Abmeldung
        </Button>

        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularCites"}}
        >
            05 EU-Bescheinigung (ehemals CITES)
        </Button>

        <Button
            color="primary"
            onClick={()=>{window.location.href = "/?form=FormularNachzucht"}}
        >
            06 Nachzucht
        </Button>
  </p>
);

export default FormularUnbestimmt;